"use strict";

exports.__esModule = true;
exports["default"] = void 0;
/**
 * Zendesk widget configuration
 * Source: https://developer.zendesk.com/embeddables/docs/widget/introduction
 */

var _default = {
  color: {
    theme: "#00b5e2"
  },
  position: {
    horizontal: "right",
    vertical: "bottom"
  },
  launcher: {
    label: {
      "*": "Chat with us"
    }
  },
  chat: {
    offlineForm: {
      greeting: {
        "*": "We aren't online right now, please leave a message"
      }
    }
  },
  contactForm: {
    attachments: false
  },
  talk: {
    suppress: true
  },
  answerBot: {
    suppress: true
  },
  helpCenter: {
    chatButton: {
      "*": "Chat with us"
    },
    messageButton: {
      "*": "Contact us for more"
    }
  }
};
exports["default"] = _default;
module.exports = exports["default"];